import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-template-details-step',
  templateUrl: './template-details-step.component.html',
  styleUrl: './template-details-step.component.css',
})
export class TemplateDetailsStepComponent {
  /** The FormGroup (created by the parent wizard) that holds templateName and templateDescription controls. */
  @Input() form!: FormGroup;
}
